module.exports = __webpack_public_path__ + "static/media/bowling.15e4d451.PNG";